import React from 'react';

import { Stack } from '@lyearn/ui';
import CoreFeedback from '@/features/feedback';
import { useArticle } from '@/modules/corporate/modules/article/articleContext';
import { EntityTypeEnum } from '@/types/schema';

import { FeedbackContainerProps } from './types';

const FeedbackContainer: React.FC<FeedbackContainerProps> = () => {
  const {
    article: { id: articleId, feedbackQuestions },
  } = useArticle();

  return (
    <Stack className="insert-padding-bottom-screen mt-36 w-full xs:mb-36" justifyContent="center">
      <CoreFeedback
        entityId={articleId}
        entityType={EntityTypeEnum.Article}
        feedbackQuestions={feedbackQuestions}
      />
    </Stack>
  );
};

export default React.memo(FeedbackContainer);
